import { render } from "./RemoteMonitoringEventItem.vue?vue&type=template&id=a2ce5bd2&ts=true"
import script from "./RemoteMonitoringEventItem.vue?vue&type=script&lang=ts"
export * from "./RemoteMonitoringEventItem.vue?vue&type=script&lang=ts"

import "./RemoteMonitoringEventItem.vue?vue&type=style&index=0&id=a2ce5bd2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__